import { render, staticRenderFns } from "./PortfolioHomeRedisigne.vue?vue&type=template&id=0a6b995e&scoped=true&"
import script from "./PortfolioHomeRedisigne.vue?vue&type=script&lang=js&"
export * from "./PortfolioHomeRedisigne.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioHomeRedisigne.vue?vue&type=style&index=0&id=0a6b995e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6b995e",
  null
  
)

export default component.exports